export default __webpack_public_path__ + "static/xeroLogo-d7ac78916a3382af2d0e0e593561af95.svg";